import { Action } from '@ngrx/store';
import { UserModel, BasicUserModel } from '../_models/user.model';

export enum AuthActionTypes {
  Login = '[Login] Action',
  Logout = '[Logout] Action',
  UserRequested = '[Request User] Action',
  UserLoaded = '[Load User] Auth API'
}

export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;
}

export class Login implements Action {
  readonly type = AuthActionTypes.Login;
}

export class UserRequested implements Action {
  readonly type = AuthActionTypes.UserRequested;
}

export class UserLoaded implements Action {
  readonly type = AuthActionTypes.UserLoaded;

  constructor(public payload: { user: BasicUserModel }) {
  }
}

export type AuthActions =
  | Logout
  | Login
  | UserRequested
  | UserLoaded;
